import moment from 'moment';

enum BonusCode {
  birthday1 = 'birthday-euphoria1',
  birthday2 = 'birthday-euphoria2',
  birthday3 = 'birthday-euphoria3',
}

export const mapTodayBonuses: Record<number, string> = {
  10: BonusCode.birthday1,
  11: BonusCode.birthday2,
  12: BonusCode.birthday3,
  13: BonusCode.birthday1,
  14: BonusCode.birthday2,
  15: BonusCode.birthday3,
  16: BonusCode.birthday1,
  17: BonusCode.birthday2,
  18: BonusCode.birthday3,
  19: BonusCode.birthday1,
  20: BonusCode.birthday2,
  21: BonusCode.birthday3,
  22: BonusCode.birthday1,
  23: BonusCode.birthday2,
  24: BonusCode.birthday3,
  25: BonusCode.birthday1,
  26: BonusCode.birthday2,
  27: BonusCode.birthday3,
  28: BonusCode.birthday1,
  29: BonusCode.birthday2,
  30: BonusCode.birthday3,
};

export const getTodayBonusCode = () => {
  const todayDate = moment.utc().date();
  return mapTodayBonuses[todayDate];
};

interface Bonus {
  title: string;
  description: string;
  prize: number;
  prize2?: number;
}

export const bonusesData: Bonus[] = [
  {
    title: 'bonuses.1.title',
    description: 'bonuses.1.description',
    prize: 100,
  },
  {
    title: 'bonuses.2.title',
    description: 'bonuses.2.description',
    prize: 10,
    prize2: 100,
  },
  {
    title: 'bonuses.3.title',
    description: 'bonuses.3.description',
    prize: 15,
    prize2: 100,
  },
];
